import useSWRInfinite from 'swr/infinite';
import { getFlexStartAndEndDate } from '../helpers/getFlexStartAndEndDate';
import { FlexCalSummary, Reservation } from '../types';

const useInfiniteReservations = (
  flexCal: FlexCalSummary,
  setIsReachingEnd: React.Dispatch<React.SetStateAction<boolean>>,
  apiUri: string
) => {
  const TWO_WEEKS_IN_MILLIS = 1209600000;
  const { start, end } = getFlexStartAndEndDate(flexCal);
  const totalPages = Math.ceil(end.diff(start, ['weeks']).weeks / 2);
  const getKey = (pageIndex: number) => {
    if (pageIndex >= totalPages) return null;
    const addToStart = pageIndex * TWO_WEEKS_IN_MILLIS;
    const addToEnd = addToStart + TWO_WEEKS_IN_MILLIS;
    const endDate = start.plus({ milliseconds: addToEnd });
    const startDate = start.plus({ milliseconds: addToStart });

    const encodedStartDate = encodeURIComponent(
      startDate.toFormat('MM/dd/yyyy, h:mm a')
    );
    const encodedEndDate = encodeURIComponent(
      endDate.toFormat('MM/dd/yyyy, h:mm a')
    );
    return `${apiUri}/lazycalendar/getReservedTimes/${flexCal.lazyCalendarId}?startDate=${encodedStartDate}&endDate=${encodedEndDate}`;
  };
  const { data, error, mutate, size, setSize, isValidating } = useSWRInfinite<
    Reservation[]
  >(getKey, { revalidateFirstPage: false });
  const reservations = data ? ([] as Reservation[]).concat(...data) : [];
  const isLoadingInitialData = !data && !error;
  const isLoadingMore =
    isLoadingInitialData ||
    (size > 0 && data && typeof data[size - 1] === 'undefined');
  const isEmpty = data?.[0]?.length === 0;
  const isRefreshing = isValidating && data && data.length === size;
  const currentLoadedPage = data?.length ? data.length : 0;
  return {
    reservations,
    isLoadingInitialData,
    isLoadingMore,
    isEmpty,
    isRefreshing,
    mutate,
    size,
    setSize,
    currentLoadedPage,
  };
};

export default useInfiniteReservations;
